import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { TermsAndConditionsRequest } from "types/schemas";
import { QueryKeys } from "../QueryKeys";
import { useApi } from "../useApi";

export const useUpdateTermsAndConditionsStatus = (
  params?: { onSuccess?: () => void; onError?: () => void },
  entity: "patient" | "therapist" = "patient",
) => {
  const { api } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (status: TermsAndConditionsRequest) =>
      entity === "therapist"
        ? api.therapist.updateTermsAcceptedStatus(status)
        : api.patient.updateTermsAcceptedStatus(status),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.fetchTermsAndConditionsStatus],
      });
      params?.onSuccess?.();
    },
    onError: () => {
      params?.onError?.();
    },
  });
};
